export const createNotificationFromDto = (payload: NotificationDto) => {
  return payload.patient_user_notifications.map((notification) => ({
    id: notification.id,
    type: notification.type,
    read: notification.is_read,
    createdAt: notification.created_at,
    notificationableId: notification.notificationable_id,
  }));
};

export const createPaginationFromDto = (payload: PaginationDto) => {
  return {
    currentPage: payload.current_page,
    totalPages: payload.total_pages,
  };
};

export interface UserNotificationDto {
  id: number;
  type: string;
  is_read: boolean;
  created_at: string;
  notificationable_id: number;
}

export interface NotificationDto {
  patient_user_notifications: UserNotificationDto[];
}

export interface PaginationDto {
  current_page: number;
  total_pages: number;
}
